// @flow

import { OctagonAlert } from 'lucide-react';

import { useEntityPermissions } from '@gandi/acl';
import { useTranslator } from '@gandi/translate';

import { ListRow } from '../../../ListRow';

type Props = { fqdn: string };

export function DomainRenewOwnerAlert({
  fqdn,
}: Props): null | React.MixedElement {
  const { __ } = useTranslator();
  const { hasPermissions } = useEntityPermissions({
    type: 'domain',
    name: fqdn,
  });

  const canViewDomain = hasPermissions(['domain:domain:read']);

  return canViewDomain ? null : (
    <ListRow density="s" intent="warning" icon={<OctagonAlert size={20} />}>
      {__(
        'Please be aware that you are about to renew a domain you do not own.',
      )}
    </ListRow>
  );
}
